if (!customElements.get('collection-links')) {
  customElements.define(
    'collection-links',
    class CollectionLinks extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onPopState = this.onPopState.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        window.addEventListener('popstate', this.onPopState);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
      }

      onClick(event) {
        const link = event.target.closest('[data-collection-handle]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

        event.preventDefault();
        if (link.getAttribute('aria-current') === 'page') return;

        const root = window.Shopify?.routes?.root || '/';
        this.load(`${root}collections/${link.dataset.collectionHandle}`);
      }

      onPopState() {
        if (window.location.pathname !== this.dataset.currentPath) {
          this.load(window.location.href, { push: false });
        }
      }

      async load(url, { push = true } = {}) {
        document.querySelector('collection-products')?.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);

          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const header = this.findSections('.collection-header', page);
          const products = this.findSections('collection-products', page);
          if (!header || !products) throw new Error('Collection sections not found');

          header.current.replaceWith(header.fresh);
          products.current.replaceWith(products.fresh);
          document.title = page.title;
          document.querySelector('collection-products')?.scrollToTop?.();

          if (push) window.history.pushState({}, '', url);
        } catch (error) {
          window.location.assign(url);
        }
      }

      findSections(selector, page) {
        const current = document.querySelector(selector)?.closest('.shopify-section');
        const fresh = page.querySelector(selector)?.closest('.shopify-section');
        return current && fresh ? { current, fresh } : null;
      }
    }
  );
}
